import React, { useEffect, useState } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { mapModifiers } from '@/utils/funtion';
import Button from '@/components/atoms/button';

interface TableProps {
  timeData: string[] | undefined;
  onSelectTime: (value: string) => void;
  slug: string;
}

const SelectTime: React.FC<TableProps> = ({ timeData, onSelectTime, slug }) => {
  const [activeIndex, setActiveIndex] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (timeData && timeData.length > 0 && activeIndex == undefined) {
      const lastIndex = timeData.length - 1;
      setActiveIndex(lastIndex);
    }
  }, [timeData]);

  const handleItemClick = async (index: number) => {
    Promise.all([
      setActiveIndex(index),
      onSelectTime((timeData as string[])[index]),
    ]);
  };

  const handlePrev = () => {
    if (activeIndex === 0) return;
    Promise.all([
      setActiveIndex((prev) => Number(prev || 0) - 1),
      onSelectTime((timeData as string[])[Number(activeIndex) - 1]),
    ]);
  };

  const handleNext = () => {
    if (activeIndex === (timeData as string[]).length - 1) return;
    Promise.all([
      setActiveIndex((prev) => Number(prev || 0) + 1),
      onSelectTime((timeData as string[])[Number(activeIndex) + 1]),
    ]);
  };

  useEffect(() => {
    if (activeIndex === null) return;
    const getItemActive = document.querySelector(`.${slug}-active`);
    if (!getItemActive) return;
    getItemActive.scrollIntoView({
      behavior: 'smooth',
      inline: 'nearest',
      block: 'nearest',
    });
  }, [activeIndex]);

  return (
    <div className="t-select-time">
      <div
        className="t-select-time_items"
        style={{ display: 'flex', gap: '6px' }}
      >
        {timeData?.map((item: string, idx: number) => {
          return (
            <Button
              key={`${item}-${item}`}
              ariaLabel="Chọn mốc thời gian"
              className={`${mapModifiers('t-select-time_item', activeIndex === idx ? 'active' : '')} ${mapModifiers(slug, activeIndex === idx ? 'active' : '')}`}
              onClick={() => handleItemClick(idx)}
              variant="secondary"
              shape={activeIndex === idx ? 'fill' : 'outline'}
              style={{ flex: 1 }}
            >
              {item}
            </Button>
          );
        })}
      </div>

      <div
        onClick={handlePrev}
        className={`t-select-time_prev  ${mapModifiers(
          't-select-time_btn',
          activeIndex === 0 && 'disabled',
        )}`}
      >
        <FiChevronLeft />
      </div>
      <div
        onClick={handleNext}
        className={`t-select-time_next  ${mapModifiers(
          't-select-time_btn',
          activeIndex === Number(timeData?.length) - 1 && 'disabled',
        )}`}
      >
        <FiChevronRight />
      </div>
    </div>
  );
};

export default SelectTime;
